var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPouce(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 8.33398V18.334",
    stroke: "#479A32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 4.89935L11.667 8.33268H16.5253C16.7841 8.33268 17.0393 8.39292 17.2707 8.50864C17.5021 8.62435 17.7034 8.79236 17.8587 8.99935C18.0139 9.20634 18.1188 9.44664 18.1651 9.70121C18.2114 9.95577 18.1978 10.2176 18.1253 10.466L16.1837 17.1327C16.0827 17.4789 15.8722 17.783 15.5837 17.9993C15.2952 18.2157 14.9443 18.3327 14.5837 18.3327H3.33366C2.89163 18.3327 2.46771 18.1571 2.15515 17.8445C1.84259 17.532 1.66699 17.108 1.66699 16.666V9.99935C1.66699 9.55732 1.84259 9.1334 2.15515 8.82084C2.46771 8.50828 2.89163 8.33268 3.33366 8.33268H5.63366C5.94373 8.33252 6.24761 8.24586 6.51112 8.08245C6.77464 7.91904 6.98734 7.68536 7.12533 7.40768L10.0003 1.66602C10.3933 1.67088 10.7801 1.76449 11.1318 1.93985C11.4836 2.1152 11.7911 2.36777 12.0315 2.67868C12.2719 2.9896 12.4389 3.35082 12.5201 3.73535C12.6013 4.11989 12.5945 4.51779 12.5003 4.89935Z",
    stroke: "#479A32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPouce);
export default __webpack_public_path__ + "static/media/pouce.1c0075d722c1ae1242689af5eb776904.svg";
export { ForwardRef as ReactComponent };